import { request } from "./requests";

const SERVICE = "/kitchenTypology/api/v1";

export const findAllKitchenTypologies = () => {
  return request.get(SERVICE + "/findAll");
}
export const findKitchenTypologiesWithTotalItem = () => {
  return request.get(SERVICE + "/findAllWithTotalItem");
};
